<template>
  <div class="mintPopup">
    <mt-popup v-model="modal.value" position="bottom">
      <!-- <img id="imgDemo" ref="imgDemo":src="imgBlobData" alt=""> -->
      <div class="wrap">
        <div class="title">
          <!-- 分享至 -->
          {{$t('share.shareTo')}}
        </div>
        <div class="content">
          <!-- <div class="item" @click="handleshare('wechatFriend')">
          <div class="icon">
            <img src="/static/img/share/wx.png" alt="" />
          </div>
          <div class="label">微信</div>
        </div>
        <div class="item" @click="handleshare('weibo')">
          <div class="icon">
            <img src="/static/img/share/wb.png" alt="" />
          </div>
          <div class="label">新浪微博</div>
        </div>
        <div class="item" @click="handleshare('qqFriend')">
          <div class="icon">
            <img src="/static/img/share/qq.png" alt="" />
          </div>
          <div class="label">QQ</div>
        </div> -->
          <template v-if="downUrl && isDownload &&(userId == uid)">
            <a :href="downUrl" v-if="!androidVx">
              <div class="item" @click="handleshare('download')" v-if="workshow">
                <div class="icon">
                  <img src="/static/img/share/download.png" alt="" />
                </div>
                <div class="label">
                  <!-- 下载文件 -->
                  {{$t('share.downFile')}}
                </div>
              </div>
            </a>
            <a href="javascript:void(0)" v-else>
              <div class="item" @click="handleshare('download')" v-if="workshow">
                <div class="icon">
                  <img src="/static/img/share/download.png" alt="" />
                </div>
                <div class="label">
                  <!-- 下载文件 -->
                  {{$t('share.downFile')}}
                </div>
              </div>
            </a>
          </template>
          <div class="item" @click="handleshare('workShare')">
            <div class="icon">
              <img src="/static/img/share/poster.png" alt="" />
            </div>
            <div class="label">
              <!-- 生成海报 -->
              {{$t('share.poster')}}
            </div>
          </div>
          <div class="item" @click="handleshare('copy')" v-copy="copyHref">
            <div class="icon">
              <img src="/static/img/share/copy.png" alt="" />
            </div>
            <div class="label">
              <!-- 复制链接 -->
              {{$t('share.copyLink')}}
            </div>
          </div>
        </div>
        <div class="footer" @click="handlecancel">
          <!-- 取消 -->
          {{$t('share.confirm')}}
        </div>
      </div>
    </mt-popup>
    <div class="posterModel" v-if="posterModelFlag">
      <div class="poster-img" :class="isBoxFlag ? 'boxposterImg':'workposterImg'">
        <img src="/static/img/share/workCLose.png" alt="" class="posterClose" @click.stop="posterImgClose" />
        <img :src="imgPoster" alt="" class="imgPoster" />
      </div>
      <div class="wrapCon">
        <div class="content" @click="downloadBase64Img">
          <div class="item" v-if="isWeixin">
            <div class="label">{{ downloadBase64Text }}</div>
          </div>
          <div class="item imgLabel" v-else>
            <div>
              <img src="/static/img/share/posterDownLoad.png" alt="" />
            </div>

            <span>
              <!-- 保存图片 -->
              {{$t('share.savePicture')}}
            </span>

            <!-- <div v-else>
              <img src="/static/img/" alt="">
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  let Base64 = require("js-base64").Base64;
  import NativeShare from "nativeshare";
  import html2canvas from "html2canvas";

  export default {
    props: {
      shareId: {
        type: Number,
        default: 0,
      },
      isBoxFlag: {
        type: Number,
        default: 1,
      },
      modal: {
        type: Object,
      },
      downUrl: {
        type: String,
      },
      userId: {
        type: Number,
        default: 0,
      },
      isDownload: {
        type: Boolean,
        default: false,
      },
      workshow: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isWeixin: false,
        nativeShare: null,
        imgBlobData: "",
        androidVx: false,
        isPoup: false,
        posterModelFlag: false,
        imgPoster: "", //海报图片
        shareUrl: "",
        posterBase64Url: "", //下载海报时调用
        downloadBase64Text: this.$i18nn.t('share.longSave'), //"长按保存图片",
        copyHref: '',
        userShareStr: '', // 用户邀请码串
        base: this.$store.state.token && Base64.decode(this.$store.state.token.split(".")[1]),
        uid: 0,
      };
    },
    watch: {
      'modal.value'(val) {
        if (!val) {
          this.move();
        }
      }
    },
    methods: {
      //海报关闭按钮
      posterImgClose() {
        this.move();
        this.posterModelFlag = false;
        this.modal.value = false;
      },
      //禁止滚动
      stop() {
        document
          .getElementsByTagName("body")[0]
          .setAttribute("style", "position:fixed; width:100%;font-size:12px");
      },
      /***取消滑动限制***/
      move() {
        document
          .getElementsByTagName("body")[0]
          .setAttribute("style", "position:relative;font-size:12px");
      },
      handlecancel() {
        this.move();
        this.modal.value = false;
      },
      copyUrl() {
        // return;
        if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
          var el = document.createElement("input");
          el.value = window.location.href; //要复制的内容
          el.style.opacity = "0";
          document.body.appendChild(el);
          var editable = el.contentEditable;
          var readOnly = el.readOnly;
          el.contentEditable = true;
          el.readOnly = false;
          const range = document.createRange();
          range.selectNodeContents(el);
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
          el.setSelectionRange(0, 999999);
          el.contentEditable = editable;
          el.readOnly = readOnly;
          var ret = document.execCommand("copy");
          el.blur();
          if (ret) {
            this.modal.value = false;
            this.$toast({
              message: this.$i18nn.t('share.copySuccess'), //"复制成功,快去粘贴给你的好友吧！",
              className: "noticeErrorToast",
            });
          } else {
            // alert("失败")
          }
        } else {
          var oInput = document.createElement("input"); //创建隐形input
          oInput.value = window.location.href; // window.location.href 浏览器URL
          document.body.appendChild(oInput);
          oInput.select();
          document.execCommand("Copy");
          oInput.remove();
          this.modal.value = false;
          this.$toast({
            message: this.$i18nn.t('share.copySuccess'), //"复制成功,快去粘贴给你的好友吧！",
            className: "noticeErrorToast",
          });
        }
      },
      getbrowser() {
        const UA = navigator.userAgent;
        const isWechat = /micromessenger/i.test(UA);
        const isQQ = /QQ\/([\d\.]+)/.test(UA);
        const isQQMBrowser = /MQQBrowser/i.test(UA) && !isWechat && !isQQ;
        return isQQMBrowser;
      },
      getSystem() {
        const userAgent = navigator.userAgent;
        const isAndroid =
          userAgent.indexOf("Android") > -1 || userAgent.indexOf("Adr") > -1; //android终端
        const isiOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        var isWeiXin =
          navigator.userAgent.toLowerCase().indexOf("micromessenger") > -1 ?
          true :
          false;
        if (isWeiXin && isAndroid) {
          this.androidVx = true;
        }
        const isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器
        const isSafari =
          userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") == -1; //判断是否Safari浏览器
        const isChrome =
          userAgent.indexOf("Chrome") > -1 &&
          userAgent.indexOf("Safari") > -1 &&
          userAgent.indexOf("UCBrowse") == -1 &&
          userAgent.indexOf("MQQBrowser") == -1;
        const isBaidu = userAgent.indexOf("Baidu") > 0;
        console.log("userAgent", userAgent);
        if (isBaidu || isChrome || isSafari || isFF) {
          return false;
        } else {
          return true;
        }
      },
      downloadBase64Img() {
        this.downloadBase64(this.posterBase64Url, "posterImg");
      },
      downloadBase64(url, name) {
        const isFirefox =
          navigator.userAgent.indexOf("Firefox") >= 0 ? true : false;
        const fileName = name + ".png";
        if (isFirefox) {
          const aLink = document.createElement("a");
          const blob = base64ToBlob(url);
          const evt = document.createEvent("HTMLEvents");
          evt.initEvent("click", true, true);
          aLink.download = fileName;
          aLink.href = URL.createObjectURL(blob);
          // aLink.click();
          aLink.dispatchEvent(
            new MouseEvent("click", {
              bubbles: true,
              cancelable: true,
              view: window,
            })
          );
        }
        if (window.navigator.msSaveOrOpenBlob) {
          // 使用ie浏览器时
          const bstr = atob(url.split(",")[1]);
          let n = bstr.length;
          const u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          const blob = new Blob([u8arr]);
          window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
          // 使用谷歌浏览器时
          const $a = document.createElement("a");
          $a.setAttribute("href", url);
          $a.setAttribute("download", fileName);
          $a.setAttribute("style", "background:#1c3756");
          $a.click();
        }
      },
      handleshare(type) {
        // alert(myBrowser());
        const isnormal = this.getSystem();
        var ua = window.navigator.userAgent.toLowerCase();
        // 通过正则表达式匹配ua中是否含有MicroMessenger字符串
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          this.isWeixin = true;
          if (type == "wechatFriend") {
            this.$toast({
              message: this.$i18nn.t('share.clickTopRight'), //"点击右上角选择好友分享",
            });
          } else if (type == "wechatTimeline") {
            this.$toast({
              message: this.$i18nn.t('share.clickTopRight1'), //"点击右上角选择朋友圈分享",
            });
          }
        }
        if (type === "copy") {
          this.$toast({
            message: this.$i18nn.t('share.copySuccess'), // "复制成功",
          });
          // this.copyUrl();
        } else if (type == "download" && !this.androidVx) {
          this.modal.value = false;
          this.$emit("handleshare", {
            downloadUrl: this.downloadUrl,
            nativeShare: this.nativeShare,
            type,
            copyUrl: this.copyUrl,
            isnormal,
          });
        } else if (type == "download" && this.androidVx) {
          // alert("微信不支持下载，请点击右上角使用其它浏览器打开！");
          //
          alert(this.$i18nn.t('share.dontSuppot'))
          return;
        } else if (type == "workShare" && this.isBoxFlag == 3) {
          //作品海报
          this.modal.value = false;
          // this.Indicator.open({
          //   text: "海报生成中",
          //   spinnerType: "fading-circle",
          // });
          this.$loading.show();
          this.$fetchql
            .Post("opus/share/poster", {
              id: this.$route.query.opusattrid - 0,
            })
            .then((res) => {
              if (res.code == 0) {
                this.stop();
                // this.Indicator.close();
                this.$loading.hide();
                this.posterModelFlag = true;
                this.modal.value = false;
                this.imgPoster = res.data;
                this.posterBase64Url = res.data;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else if (type == "workShare" && this.isBoxFlag == 2) {
          //抽奖盲盒海报
          this.modal.value = false;
          // this.Indicator.open({
          //   text: "海报生成中",
          //   spinnerType: "fading-circle",
          // });
          this.$loading.show();
          this.$fetchql
            .Post("pack/share/poster", {
              id: this.$route.query.lotterCodeId - 0,
            })
            .then((res) => {
              if (res.code == 0) {
                this.stop();
                // this.Indicator.close();
                this.$loading.hide();
                this.posterModelFlag = true;
                this.modal.value = false;
                this.imgPoster = res.data;
                this.posterBase64Url = res.data;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else if (type == "workShare" && this.isBoxFlag == 1) {
          //盲盒海报
          this.modal.value = false;
          // this.Indicator.open({
          //   text: "海报生成中",
          //   spinnerType: "fading-circle",
          // });
          this.$loading.show();
          var params = {
            id: this.shareId ? this.shareId : this.$route.query.id - 0,
          }
          this.$fetchql
            .Post("pack/share/poster", params)
            .then((res) => {
              if (res.code == 0) {
                this.stop();
                // this.Indicator.close();
                this.$loading.hide();
                this.posterModelFlag = true;
                this.modal.value = false;
                this.imgPoster = res.data;
                this.posterBase64Url = res.data;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else if (type == "workShare" && this.isBoxFlag == 4) {
          //杰威尔
          this.modal.value = false;
          this.$loading.show();
          var params = {
            id: this.$route.query.id - 0,
            pId: this.shareId
          }
          this.$fetchql
            .Post("activity/subject/share/poster", params)
            .then((res) => {
              if (res.code == 0) {
                this.stop();
                // this.Indicator.close();
                this.$loading.hide();
                this.posterModelFlag = true;
                this.modal.value = false;
                this.imgPoster = res.data;
                this.posterBase64Url = res.data;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.modal.value = false;
          this.$emit("handleshare", {
            nativeShare: this.nativeShare,
            type,
            copyUrl: this.copyUrl,
            isnormal,
          });
        }
        // this.modal.value = false;
      },
      createshare() {
        // 先创建一个实例
        this.nativeShare = new NativeShare();
        // // 如果你需要在微信浏览器中分享，那么你需要设置额外的微信配置
        // // 特别提示一下微信分享有一个坑，不要分享安全域名以外的链接(具体见jssdk文档)，否则会导致你配置的文案无效
        // // 创建实例应该带参数
        // var nativeShare = new NativeShare({
        //   wechatConfig: {
        //     appId: "",
        //     timestamp: "",
        //     nonceStr: "",
        //     signature: "",
        //   },
        //   // 让你修改的分享的文案同步到标签里，比如title文案会同步到<title>标签中
        //   // 这样可以让一些不支持分享的浏览器也能修改部分文案，默认都不会同步
        //   syncDescToTag: false,
        //   syncIconToTag: false,
        //   syncTitleToTag: false,
        // });

        // 你也可以在setConfig方法中设置配置参数
        // nativeShare.setConfig({
        //   wechatConfig: {
        //     appId: "",
        //     timestamp: "",
        //     nonceStr: "",
        //     signature: "",
        //   },
        // });
        // let link = window.location.href;
        // // 设置分享文案
        // this.nativeShare.setShareData({
        //   icon: "https://pic3.zhimg.com/v2-080267af84aa0e97c66d5f12e311c3d6_xl.jpg",
        //   link,
        //   title: "NativeShare",
        //   desc: "NativeShare是一个整合了各大移动端浏览器调用原生分享的插件",
        //   from: "@fa-ge",
        // });
      },
      //获取用户邀请码串
      getUserShareStr() {
        this.$fetchql.Post("activity/receive/inviteStr", {
          id: this.shareId ? this.shareId : this.$route.query.id - 0
        }).then((result) => {
          if (result.code == 0) {
            this.userShareStr = result.data;
            this.copyHref = location.href + this.userShareStr;
          }
        });
      },
    },
    mounted() {
      console.log(this.base)
      if (this.base) this.uid = JSON.parse(this.base).id
      this.createshare();
      if (this.$store.state.token && (location.href.indexOf('inviteBoxDetail') != -1 || location.href.indexOf(
          'infiniteBoxDetail') != -1 || location.href.indexOf(
          'actKeys') != -1)) {
        this.getUserShareStr();
      } else {
        this.copyHref = location.href
      }
    },
    destroyed() {
      this.move();
    },
  };

</script>

<style lang="less" scoped>
  .imgLabel {
    text-align: center;
    color: #c7c7d3;
    font-size: 12px;

    div {
      width: 45px;
      height: 45px;
      background: #444444;
      border-radius: 50%;
      margin-bottom: 7.5px;
    }

    img {
      width: 20.5px !important;
      height: 16px !important;
      margin: 15.25px auto auto auto !important;
      vertical-align: middle;
      display: inline-block !important;
    }
  }

  .wrap {
    width: 100vw;
    background: #2a2a2a;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }

    .title {
      padding: 29px 0;
      text-align: center;
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      font-size: 17px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #ffffff;
      line-height: 14px;
    }

    .content::-webkit-scrollbar {
      display: none;
    }

    .content {
      text-align: left;
      border-bottom: 1px solid #414141;
      overflow-x: scroll;
      white-space: nowrap;
      // display: flex;
      // justify-content: space-between;
      // padding: 3px 22px 30px 22px;
      padding: 0 14px;

      .item {
        display: inline-block;
        text-align: center;
        margin: 0 15px 30px 15px;

        .icon {
          width: 45px;
          height: 45px;
          margin: 0 auto 10px;

          img {
            width: 45px;
            height: 45px;
          }
        }

        .label {
          text-align: center;
          font-size: 12px;
          font-weight: 400;
          color: #8d8f9f;
        }
      }
    }

    .footer {
      text-align: center;
      font-size: 16px;
      font-weight: 500;
      color: #bdbdbd;
      padding: 16px 0;
    }

    a {
      text-decoration: none;
    }

    a {
      outline: none;
    }

    a:focus-visible {
      outline: none;
    }
  }

  .posterModel {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100vh;
    background: #343434;
    z-index: 999;

    .poster-img {
      position: relative;
      width: 300px;
      height: 500px;
      margin: 95px auto 0 auto;

      &.boxposterImg {
        height: 500px;
      }

      &.workposterImg {
        height: 500px;
      }

      .posterClose {
        width: 18.5px;
        height: 18.5px;
        position: absolute;
        right: 10px;
        top: -30px;
      }

      .imgPoster {
        width: 100%;
        height: 100%;
      }
    }

    .wrapCon {
      width: 320px;
      margin: 19px auto 0 auto !important;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }

      .title {
        padding: 23px 0;
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        color: #ffffff;
      }

      .content {
        display: flex;
        justify-content: space-evenly;
        padding: 3px 22px 30px 22px;

        .item {
          .icon {
            width: 20.5px !important;
            height: 16px !important;
            display: inline-block;

            img {
              vertical-align: middle !important;
            }
          }

          .label {
            text-align: center;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: bold;
            color: #fff;
            height: 45px;
            line-height: 45px;
            // background: url(/static/img/share/downloadBg.png);
            background-size: 100% 100%;
            width: 300px;
            margin: 0 auto;
          }
        }
      }

      .footer {
        width: 35px;
        height: 35px;
        margin: 0 auto;
        background: url(../../static/img/boxdetail/close-model-btn.png) 0% 0% / 100% 100%;
      }
    }
  }

</style>
<style>
  .noticeErrorToast {
    z-index: 9000 !important;
  }

  .mintPopup {
    /* min-height: 420px; */
    background: #2a2a2a !important;
    border-radius: 40px 40px 0px 0px;
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    z-index: 99999;
    top: auto;
    right: auto;
    bottom: 0;
    left: 0%;
  }

  .mintPopup .mint-popup {
    background: none !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Share.vue